module.exports = __webpack_public_path__ + "static/whale-6f6f7931f4a6481ea645a791b37e7c45.mp4";